import './Box.scss';

type BoxProps = {
  children: JSX.Element;
  bgColor: 'aqua' | 'lilac' | 'red' | 'aqua-dark';
  classes?: string;
};

function Box({ children, bgColor, classes }: BoxProps): JSX.Element {
  return <div className={`box ${bgColor} ${classes}`}>{children}</div>;
}

export default Box;
